
import { useState } from 'react';

export default function AnchorHeroSection() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [copyStatus, setCopyStatus] = useState<'idle' | 'success'>('idle');

  const wechatId = 'nandiangucha888';
  const phoneNumber = '400-888-9999';

  const handleCopyWechat = async () => {
    try {
      await navigator.clipboard.writeText(wechatId);
      setCopyStatus('success');
      setTimeout(() => setCopyStatus('idle'), 2000);
    } catch (err) {
      // 降级方案
      const textArea = document.createElement('textarea');
      textArea.value = wechatId;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopyStatus('success');
      setTimeout(() => setCopyStatus('idle'), 2000);
    }
  };

  const handlePhoneCall = () => {
    window.open(`tel:${phoneNumber}`);
  };

  return (
    <>
      <section 
        id="hero"
        className="relative min-h-[80vh] flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/36aaf3f1745139626b5131214c147414.jpg')`
        }}
      >
        <div className="container mx-auto px-6 relative z-10">
          <div className="w-full text-center">
            <div className="space-y-8">
              <h1 className="text-2xl md:text-4xl lg:text-6xl font-bold text-white leading-tight">
                主播合作计划
                <span className="block text-blue-400 mt-2">共创茶叶直播新时代</span>
              </h1>
              
              <p className="text-base md:text- xl lg:text-2xl text-white/90 leading-relaxed max-w-4xl mx-auto">
                携手优质主播，打造专业茶叶直播间
                <br />
                提供优质货源、专业培训、全程支持
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
                <a href="#application" className="cursor-pointer">
                  <button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-full font-semibold text-sm md:text-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap">
                    <i className="ri-live-line mr-2"></i>
                    立即申请合作
                  </button>
                </a>
                <button 
                  onClick={() => setIsContactModalOpen(true)}
                  className="border-2 border-white text-white hover:bg-white hover:text-gray-800 px-8 py-4 rounded-full font-semibold text-sm md:text-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line mr-2"></i>
                  咨询合作详情
                </button>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto mt-12">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-xl md:text-3xl font-bold text-blue-400 mb-1">500+</div>
                  <div className="text-sm md:text-base text-white">合作主播</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-xl md:text-3xl font-bold text-blue-400 mb-1">1000万+</div>
                  <div className="text-sm md:text-base text-white">月观看量</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-xl md:text-3xl font-bold text-blue-400 mb-1">85%</div>
                  <div className="text-sm md:text-base text-white">转化率</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-xl md:text-3xl font-bold text-blue-400 mb-1">30%+</div>
                  <div className="text-sm md:text-base text-white">佣金比例</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <a href="#benefits" className="cursor-pointer">
            <i className="ri-arrow-down-line text-white text-2xl"></i>
          </a>
        </div>
      </section>

      {/* Contact Modal */}
      {isContactModalOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-auto transform transition-all duration-300">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100">
              <h3 className="text-xl font-bold text-gray-800 flex items-center">
                <i className="ri-customer-service-line text-blue-600 mr-2"></i>
                联系我们
              </h3>
              <button
                onClick={() => setIsContactModalOpen(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-gray-600"></i>
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 space-y-6">
              {/* Phone */}
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-phone-line text-blue-600"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500">客服热线</div>
                    <div className="font-semibold text-gray-800">{phoneNumber}</div>
                  </div>
                </div>
                <button
                  onClick={handlePhoneCall}
                  className="w-full bg-blue-50 hover:bg-blue-100 text-blue-600 py-3 px-4 rounded-xl transition-colors cursor-pointer font-medium"
                >
                  <i className="ri-phone-line mr-2"></i>
                  点击拨打电话
                </button>
              </div>

              {/* WeChat */}
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-wechat-line text-green-600"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500">微信号</div>
                    <div className="font-semibold text-gray-800">{wechatId}</div>
                  </div>
                </div>
                <button
                  onClick={handleCopyWechat}
                  className={`w-full py-3 px-4 rounded-xl transition-all cursor-pointer font-medium ${
                    copyStatus === 'success' 
                      ? 'bg-green-50 text-green-600' 
                      : 'bg-green-50 hover:bg-green-100 text-green-600'
                  }`}
                >
                  {copyStatus === 'success' ? (
                    <>
                      <i className="ri-check-line mr-2"></i>
                      已复制微信号
                    </>
                  ) : (
                    <>
                      <i className="ri-file-copy-line mr-2"></i>
                      复制微信号
                    </>
                  )}
                </button>
                
                {/* WeChat Note */}
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                  <div className="flex items-start">
                    <i className="ri-information-line text-amber-600 mt-0.5 mr-2"></i>
                    <div className="text-sm text-amber-800">
                      <div className="font-medium mb-1">添加微信时请注明：</div>
                      <div>来意和账号信息</div>
                      <div className="text-amber-700 mt-1">
                        例如：某某某账号寻求普洱茶货盘定制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="px-6 pb-6">
              <div className="text-center text-sm text-gray-500">
                工作时间：周一至周日 9:00-21:00
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
